/**
 * Cache key constants used throughout the application
 * Centralized definitions to prevent key conflicts and typos
 */

import { clear } from 'idb-keyval';

/**
 * Storage key prefixes for PaginatedCache
 */
export const CACHE_PREFIXES = {
  CONVERSATIONS: 'conversation-cache',
  MESSAGES: 'message-cache',
} as const;

/**
 * Direct IndexDB storage keys (not using PaginatedCache)
 */
export const CACHE_KEYS = {
  CONVERSATION_METADATA: (conversationId: string) =>
    `conversation-metadata:${conversationId}`,
} as const;

/**
 * Clear all application caches from IndexedDB
 * Should be called on logout to prevent data leakage between users
 */
export const clearAllCaches = async (): Promise<void> => {
  try {
    await clear();
    console.log('Cleared all cached entries on logout');
  } catch (error) {
    console.error(
      `Failed to clear caches: ${
        error instanceof Error ? error.message : 'Unknown error'
      }`,
    );
  }
};
